export const fonts = {
    roboto: 'Roboto Condensed',
    flameBold: 'Flame Bold',
    flameRegular: 'Flame Regular',
    flameSansRegular: 'Flame Sans Regular'
}
